export class OnboardingFile {
    FileName: string;
    Data: string;
    Mime: string;

    constructor(source?: Partial<OnboardingFile>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}